import { SelectButton } from "primereact/selectbutton";
import {
  DeviceTypeCategory,
  DeviceTypeCategoryGerman,
} from "../../../../../api/firebase/types/device.types";

const deviceTypeOptions = [
  {
    name: DeviceTypeCategoryGerman.HARDWARE_DEVICE,
    value: DeviceTypeCategory.HARDWARE_DEVICE,
  },
  {
    name: DeviceTypeCategoryGerman.DESKTOP_CLIENT,
    value: DeviceTypeCategory.DESKTOP_CLIENT,
  },
];

type DeviceSelectButtonProps = {
  deviceType: DeviceTypeCategory;
  setDeviceType: (type: DeviceTypeCategory) => void;
};

const DeviceSelectButton: React.FC<DeviceSelectButtonProps> = ({
  deviceType,
  setDeviceType,
}) => {
  return (
    <SelectButton
      value={deviceType}
      options={deviceTypeOptions}
      optionLabel="name"
      onChange={(e) => setDeviceType(e.value)}
    />
  );
};

export default DeviceSelectButton;
